import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import LandingNavbar from '../../components/LandingNavbar';
import LandingFooter from '../../components/LandingFooter';
import '../LandingPage.css';

const ExpenseTrackerIndia = () => {
  return (
    <div className="seo-page">
      <Helmet>
        <title>Best Expense Tracker App for India | Hisab OK Hai - Free</title>
        <meta name="description" content="India ka best free expense tracker app. Daily kharcha track karo, budget banao, reports dekho. Simple, fast aur secure. Abhi free mein shuru karein." />
        <meta name="keywords" content="expense tracker india, expense tracker app, free expense tracker, kharcha tracker india, money tracker india, personal finance india" />
        <link rel="canonical" href="https://hisabokhai.in/expense-tracker-india" />
      </Helmet>

      <LandingNavbar />

      <section className="seo-page-hero">
        <h1>Best Expense Tracker App for India</h1>
        <p>Har din ka kharcha track karo, budget banao, aur apne paison pe control rakho — bilkul free.</p>
        <Link to="/signup" className="cta-primary">Free Mein Try Karein</Link>
      </section>

      <div className="seo-content">
        <h2>India Mein Expense Tracking Kyun Zaroori Hai?</h2>
        <p>
          India mein zyada tar log apne daily expenses track nahi karte. Mahine ke end mein pata nahi chalta ki paisa kahan gaya.
          Ek reliable expense tracker app se aap apne financial habits samajh sakte ho aur behtar decisions le sakte ho.
        </p>

        <h2>Hisab OK Hai Kyun Choose Karein?</h2>
        <p>
          Hisab OK Hai specifically India ke users ke liye bana hai. Simple interface, Hindi-English mix language,
          aur wo sab features jo aam Indian household aur small business ko chahiye.
        </p>
        <ul>
          <li>Multiple ledgers — ghar, business, personal sab alag</li>
          <li>Category-wise expense tracking</li>
          <li>Monthly aur yearly reports with charts</li>
          <li>Budget planning aur alerts</li>
          <li>Vendor aur udhari management</li>
          <li>Payment reminders</li>
          <li>Receipt upload facility</li>
          <li>Secure aur fast — India-based hosting</li>
        </ul>

        <h2>Kaise Kaam Karta Hai?</h2>
        <p>
          Signup karein, apna pehla ledger banayein, aur daily expenses add karna shuru karein.
          App automatically reports generate karega, budget track karega, aur payment reminders bhejega.
        </p>

        <h2>Kya Yeh Free Hai?</h2>
        <p>
          Haan! Hisab OK Hai start karna bilkul free hai. Core features — expense tracking, reports,
          categories, reminders — sab free mein available hain.
        </p>

        <div className="seo-cta-box">
          <h3>Try Hisab OK Hai for Free</h3>
          <p style={{color: '#555', marginBottom: '16px'}}>Apna expense tracking abhi shuru karein — signup karein aur 2 minute mein ready.</p>
          <Link to="/signup" className="cta-primary">Free Sign Up</Link>
          <div style={{marginTop: '12px'}}>
            <Link to="/login" style={{color: '#27AE60', fontSize: '0.9rem'}}>Already have an account? Login</Link>
          </div>
        </div>

        <div className="seo-internal-links">
          <h3>Explore More Features</h3>
          <div className="seo-links-grid">
            <Link to="/" className="seo-link-card">
              <span className="seo-link-icon">&#127968;</span> Home
            </Link>
            <Link to="/daily-expense-tracker" className="seo-link-card">
              <span className="seo-link-icon">&#128197;</span> Daily Expense Tracker
            </Link>
            <Link to="/udhari-management-app" className="seo-link-card">
              <span className="seo-link-icon">&#128221;</span> Udhari Management
            </Link>
            <Link to="/budget-planner-india" className="seo-link-card">
              <span className="seo-link-icon">&#128200;</span> Budget Planner
            </Link>
          </div>
        </div>
      </div>

      <LandingFooter />
    </div>
  );
};

export default ExpenseTrackerIndia;
